var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('power-bi',{attrs:{"code":"eyJrIjoiYjYxMTAwNjQtNGM3Zi00ZGM5LTkwMmEtZDRiZTg3N2YwNDhjIiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9"}})}
var staticRenderFns = []

export { render, staticRenderFns }